<template>
  <component
    :is="type"
    v-chakra
    background="white"
    borderLeftRadius="0"
    borderRightRadius="full"
    overflow="hidden"
  >
    <c-box position="relative" :p="{ base: '3% 20% 17% 3%', md: '15% 20% 23% 3%' }">
      <!-- main_images seem to be typically 1280px x 905px -->
      <c-aspect-ratio-box :ratio="1280 / 905" @click="setIndex(currentPreviewIndex)">
        <c-image :src="currentPreviewHref" alt="" object-fit="contain" cursor="zoom-in" />
      </c-aspect-ratio-box>
      <c-box w="100%" textAlign="center" position="absolute" bottom="15%" pr="20%" pl="3%">
        <c-box
          v-for="(image, imageIndex) in items"
          :key="imageIndex"
          cursor="pointer"
          d="inline-block"
          w="calc(6% + 6px)"
          pb="6%"
          ml="1.5%"
          mr="1.5%"
          :background="imageIndex === currentPreviewIndex ? 'brand.purple' : 'brand.gray'"
          borderRadius="full"
          border="3px solid white"
          @click="changePreview(imageIndex)"
        />
      </c-box>
    </c-box>
    <gallery
      v-if="items"
      :images="items"
      :index="mutableIndex"
      :options="{ fullScreen: false, youTubePlayerVars: { playsinline: false } }"
      @close="setIndex(null)"
    />
  </component>
</template>

<script>
import VueGallery from "vue-gallery";
import { CBox, CAspectRatioBox, CImage } from "@chakra-ui/vue";
export default {
  name: "Gallery",
  hideFromDocs: true,
  status: "prototype",
  release: "0.0.1",
  components: {
    gallery: VueGallery,
    CBox,
    CAspectRatioBox,
    CImage,
  },
  props: {
    /**
     * The html element name used for the component.
     */
    type: {
      type: String,
      default: "div",
    },
    /**
     * Items
     */
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      mutableIndex: -1,
      currentPreviewHref: this.items[0].href,
      currentPreviewIndex: 0,
    };
  },
  methods: {
    setIndex(index) {
      this.mutableIndex = index;
    },
    changePreview(index) {
      this.currentPreviewIndex = index;
      this.currentPreviewHref = this.items[index].href;
    },
  },
  watch: {
    items() {
      this.changePreview(0);
    },
  },
};
</script>
